<template>
	<div id="equipment" class="gcardfr" v-loading="loading">
		<ImportTarr :config='taconfig'></ImportTarr>
		<el-row :gutter="gutVal" class>
			<el-col :span="24">
				<el-button size="small" @click="ImportEquip">{{ $t("terminal.import_btn") }}
				</el-button>
			</el-col>
		</el-row>
		<el-row :gutter="gutVal" class="gtbtop">
			<el-col :offset="0" :span="6" ssshow="$isAdminType() || $isProdType()">
				<div class="glineflex">
					<div class="left_label">
						<label>{{ $t("terminal.app_distributor") }}：</label>
					</div>
					<div class="right_label">
						<el-select filterable v-model="select_form.clientKey" @change="getList" :size="$ctrlSize"
							clearable style="width: 100%;" :placeholder="$t('app_select')">
							<el-option v-for="item in mech_list" :key="item.agentId" :label="item.agentName"
								:value="item.clientKey">
							</el-option>
						</el-select>
					</div>
				</div>
			</el-col>
			<el-col :span="6" oooffset="$isAdminType() || $isProdType()?0:5">
				<div class="glineflex">
					<div class="left_label">
						<label @click="hideClick">状态：</label>
					</div>
					<div class="right_label">
						<el-select :size="$ctrlSize" v-model="select_form.status" clearable style="width: 100%;"
							:placeholder="$t('app_select')" @change="getList">
							<el-option v-for="(item,index) in status_list" :key="index" :label="item" :value="index">
							</el-option>
						</el-select>
					</div>
				</div>
			</el-col>
			<el-col :span="6">
				<div class="glineflex">

					<div class="left_label">
						<label>{{ $t('terminal.device_sn') }}：</label>
					</div>
					<div class="right_label" style="display: flex;align-items: center;">
						<el-input style="min-width: 70%;" size="small" v-model="select_form.deviceId"
							@keyup.enter.native="getList" :placeholder="$t('terminal.device_sn')">
						</el-input>
					</div>
				</div>
			</el-col>
			<el-col :span="6">
				<div class="glineflex">

					<div class="left_label">
						<label>smid：</label>
					</div>
					<div class="right_label" style="display: flex;align-items: center;">
						<el-input style="min-width: 70%;" size="small" v-model="select_form.smid"
							@keyup.enter.native="getList" placeholder="smid">
						</el-input>
					</div>
				</div>
			</el-col>
		</el-row>
		<el-table ref="multipleTable" class="gtbtop" tooltip-effect="dark" :data="tableData"
			@selection-change="batchSelected"   @sort-change="sortChange" style="width: 100%">
			<!-- <el-table-column type="selection" width="55"></el-table-column> -->
			<el-table-column prop="deviceId" :label="$t('terminal.device_sn')" width>
			</el-table-column>
			<el-table-column prop="agreementNo" label="入网编号" width></el-table-column>
			<el-table-column prop="smid" label="smid" width></el-table-column>
			<el-table-column prop="supplierId" label="设备型号" width></el-table-column>
			<el-table-column prop="status" label="状态" width>
				<template slot-scope="scope">
					<span>{{ status_list[scope.row.status] }}</span>
				</template>
			</el-table-column>
			<el-table-column prop="errCode" label="错误码" width show-overflow-tooltip> </el-table-column>
			<el-table-column :label="$t('app_operation')" width="180">
				<template slot-scope="scope">
					<el-button type="text" @click="toDetail(scope.row)">上报记录</el-button>
					<!--<el-button type='text' :disabled="scope.row.bdStatus==0? true:false" @click='unbind(scope.row)'>{{$eqBindOper[scope.row.bdStatus ==0? 0:1+ '']}}</el-button>-->
					<label  class="opbline">|</label>
					<el-button :disabled="scope.row.status == 1 ? false : true" @click="delRow(scope.row)" type="text" class="opdcolor">
						解绑
					</el-button>
				</template>
			</el-table-column>
		</el-table>

		<Pages class="gpages" :cpage="page" :ctotal="total" :config="pconfig"></Pages>



		<ImportEquip :config="config"></ImportEquip>
		<el-dialog class="gstdia" :title="$t('terminal.import_btn')" :visible.sync="showImport" @close="closeDia">
			<el-form :model="import_form" v-loading="loading"  :rules="rules"  ref="ruleForm">
				<el-form-item label="" :label-width="fwidth">
					<div class="ipeqnum">1</div>
					<div class="ipeqspl"></div>
					<div>
						<label slot="trigger" class="ipeqtt">{{ $t("app_download_template") }}</label>
						<el-button slot="trigger" style="margin-left: 10px" size="mini" type="primary"
							@click="downTempFile">
							<i class="el-icon-document"></i>
							{{ $t("app_download") }}
						</el-button>
					</div>
					<div class="el-upload__tip" style="font-size: 14px">
						{{ $t("app_download_device_message") }}
					</div>
				</el-form-item>
				<el-form-item label="" :label-width="fwidth">
					<div class="ipeqnum">2</div>
					<div>
						<el-upload class="upload-demo" ref="upload" name="file" :multiple="false" :action="saction"
							:before-upload="uploadBefore" :on-success="uploadSuccess" :on-change="uploadChange"
							:headers="header" :show-file-list="false" :auto-upload="false"  :data="import_form" >
							<label slot="trigger" class="ipeqtt">{{ $t("app_upload_template") }}</label>
							<el-button slot="trigger" style="margin-left: 10px" size="mini" type="primary">
								<i class="el-icon-upload2"></i>
								{{ $t("app_upload") }}
							</el-button>
							<label slot="trigger" style="margin-left: 10px">
								{{ cfile ? cfile.name : $t("app_unupload_file") }}
							</label>
							<div slot="tip" class="el-upload__tip" style="font-size: 14px">
								{{ $t("app_upload_completed_device") }}
							</div>
						</el-upload>
					</div>
					<div></div>
				</el-form-item>

				<el-form-item label="" :label-width="fwidth"  prop="clientKey">
					<div class="ipeqnum">3</div>
					<div class="ipeqspl1"></div>
					<label class="ipeqtt">{{ $t("app_choose_vendor") }}：</label>
					<el-select filterable v-model="import_form.clientKey" clearable style="width: 100%;"
						:placeholder="$t('app_select')">
						<el-option v-for="item in mech_list" :key="item.agentId" :label="item.agentName"
							:value="item.clientKey">
						</el-option>
					</el-select>
				</el-form-item>


				<el-form-item :label-width="fwidth">
					<el-button @click="closeDia">{{ $t("app_cancel") }}</el-button>
					<el-button :disabled="!ready" type="primary" @click="submitUpload">{{ $t("app_imp") }}</el-button>
				</el-form-item>
			</el-form>
		</el-dialog>


	</div>
</template>

<style>
	.eqvltip {
		color: rgba(0, 0, 0, 0.85);
	}

	.eqvlicon {
		width: 14px;
		height: 14px;
		margin: 0;
		padding: 0;
	}

	.eqbs-ball-green {
		width: 6px;
		height: 6px;
		display: inline-block;
		border-radius: 6px;
		overflow: hidden;
		background: rgba(82, 196, 26, 1);
	}

	.eqbs-ball-gray {
		width: 6px;
		height: 6px;
		display: inline-block;
		border-radius: 6px;
		overflow: hidden;
		background: rgba(191, 191, 191, 1);
	}
</style>

<script>
	import Pages from "@/components/Pages.vue";
	import ImportEquip from "@/components/ImportEquip.vue";
	import ImportTarr from "@/components/ImportTarr.vue";
	import ExportEq from "@/components/ExportEq.vue";
	import EquipMove from "@/components/EquipMove.vue";
	import Merchant from "@/components/Merchant.vue";
	import Model from "@/components/Model.vue";
	import vic from "@/assets/eq_vlic.png";
	import vdw from "@/assets/eq_vldw.png";


	const dfkey = "UWN1NI8e58e0mdrPi9hk3AQxSvOVTgB3"
	export default {
		data() {
			return {
				mech_list: [],
				select_form: {

				},
				import_form: {
					clientKey:""
				},
				showImport: false,
				header: {
					token: localStorage.token,
				},




				saction: this.$squeImpAction(),
				cfile: {},
				fwidth: "60px",
				showIpRs: false,
				importData: [],
				show_import: false,
				ready: false,
				diaform: {},




				networkType_list: [{
						id: 1,
						name: "WIFI",
						value: 1,
					},
					{
						id: 2,
						name: "2G+WIFI",
						value: 2,
					},
					{
						id: 3,
						name: "4G+WIFI",
						value: 3,
					}, {
						id: 4,
						name: "4G",
						value: 4,
					},
					{
						id: 5,
						name: "2G",
						value: 5,
					}
				],
				status_list: ["未绑定", "已绑定", "绑定失败", "解绑失败"],
				model_type_list: [{
						id: 0,
						name: "KS8303",
						value: "KS8303",
					},
					{
						id: 1,
						name: "ZTMD711",
						value: "ZTMD711",
					},
					{
						id: 2,
						name: "ZTMD715",
						value: "ZTMD715",
					},
					{
						id: 3,
						name: "KS8303 Plus",
						value: "KS8303 Plus",
					}

				],
				sig: -100,
				sig1: 100,
				isLike: false,
				ssort: '',
				taconfig: {},
				pdform: {
					order: '',
					mech: '',
					model: "",
					type: '0'
				},
				showpdip: false,
				showDelAll: false,
				emConfig: "",
				eeconfig: {},
				sortMc: {},
				editMc: {},
				editModel: {},
				showDiaBc: false,
				isEdit: false,
				icon_vic: vic,
				icon_vdw: vdw,
				model: "",
				networkType: "",
				srcEquip: "",
				pconfig: "",
				tableData: [],
				showDia: false,
				ccount: 0,
				deviceUpdown: "",
				bcform: {
					mech: "",
					model: "",
					productkey: "",
					num: 1,
					start: "",
					end: "",
					skey: dfkey,
					isdy: false,
					fix: "",
					dfkey: dfkey,
					ever: '1'
				},
				tform: {},
				page: 1,
				total: 0,
				loading: false,
				dloading: false,
				sRows: [],
				optionsProduct: [],
				config: "",
				rules: {
					clientKey: [
					  { required: true, message:this.$t("app_select"), trigger: 'blur' }
					],
				},
				rules1: {
					order: [{
						required: true,
						message: this.$t("app_select"),
						trigger: "blur"
					}],
					mech: [{
						required: true,
						message: this.$t("app_select"),
						trigger: "blur"
					}],
					model: [{
						required: true,
						message: this.$t("app_select"),
						trigger: "blur"
					}],
					productkey: [{
						required: true,
						message: this.$t("app_select"),
						trigger: "blur"
					}],
					skey: [{
						required: true,
						message: this.$t("app_input"),
						trigger: "blur"
					}],
					fix: [{
						required: true,
						message: this.$t("app_input"),
						trigger: "blur"
					}],
					type: [{
						required: true,
						message: this.$t("app_select"),
						trigger: "blur"
					}],
					num: [{
						type: "number",
						min: 1,
						required: true,
						message: this.$t("app_input_num"),
						trigger: "blur"
					}],
					start: [{
						pattern: /^\d*$/,
						required: true,
						message: this.$t("app_input_start"),
						trigger: "blur"
					}]
				},
				gutVal: 20,
				mcVl: "",
				stVl: ""
			};
		},
		components: {
			Pages,
			ImportEquip,
			Merchant,
			Model,
			EquipMove,
			ExportEq,
			ImportTarr
		},
		methods: {
			submitUpload() {
				
				this.$refs["ruleForm"].validate(valid => {
					if (valid) { 
						this.loading = true
						this.$refs.upload.submit()
					}
				});
			},
			uploadChange(file, fileList) {
				this.cfile = file
				this.ready = file ? true : false
			},
			uploadBefore(file) {
				console.log('before', file)
			},
			uploadSuccess(res, raw) {
				this.loading = false
				if (res.status == 200) {
					this.$message.success(res.message)
					this.closeDia()
					this.getList()
				} else {
					this.$message.error(res.message)
				}
			},
			downTempFile() {
				this.$squeexportTemplate({
				}, (res) => {
					this.download(res, "导入设备模板")
				}, (err) => {
					this.$message.error(err.body.message)
				})
			},
			download(data, name) {
				// saveAs(data, "导出设备列表.xls")
				// 下载文件
				const blob = new Blob([data]);
				const url = URL.createObjectURL(blob);
				const link = document.createElement('a');
				link.href = url;
				link.download = name + '.xls';
				link.click();
			},




			ImportTa() {
				var _this = this;
				this.taconfig = {
					// pid: this.detail.id,
					showDia: true,
					callback: data => {
						_this.getList();
					}
				};
			},
			mdTArray() {
				this.ImportTa()
			},
			sortChange(obj) {
				console.log(obj)
				switch (obj.prop) {
					case "deviceid":
						this.ssort = "";
						if (obj.order == 'ascending') {
							this.deviceUpdown = 1;
						} else {
							this.deviceUpdown = 0;
						}
						break;
					case "netsignal":
						this.deviceUpdown = "";
						if (obj.order == 'ascending') {
							this.ssort = 1;
						} else {
							this.ssort = 0;
						}
						break;
					default:
						break;
				}
				this.searchEquip()
			},
			hideClick() {
				this.ccount++;
				if (this.ccount >= 6) {
					this.showDelAll = true;
				}
			},
			expEq() {
				var _this = this;
				this.eeconfig = {
					callback: () => {
						_this.getList();
					}
				};
			},
			moveEQ() {
				var _this = this;
				this.emConfig = {
					agid: "",
					showDia: true,
					callback: () => {
						_this.getList();
					}
				};
			},
			delAll() {
				this.$showMsgBox(
					this.$t("terminal.sure_delete_device"),
					() => {
						this.loading = true;
						var status = this.stVl ? this.stVl : "";
						var src = this.srcEquip ? this.srcEquip : "";
						var ag = this.mcVl;
						this.$delAllEq(
							ag,
							status,
							src,
							res => {
								this.loading = false;
								if (res.status == 200) {
									this.getList();
									this.$message.success(res.message);
								} else {
									this.$message.error(res.message);
								}
							},
							() => {
								this.loading = false;
							}
						);
					},
					""
				);
			},
			checkChange(is) {
				if (!is) {
					this.bcform.skey = this.bcform.dfkey;
				}
			},
			checkChange1(is) {
				if (!is) {
					this.tform.devicesecret = this.tform.dfkey;
				}
			},
			numChange(vl) {
				if ((vl || vl > 0) && this.bcform.start) {
					var pnum = parseInt(this.bcform.start);
					var slen = this.bcform.start.length;
					var end = pnum + this.bcform.num - 1 + "";
					var elen = end.length;
					if (slen - elen > 0) {
						//////// 结束位补0
						var len = slen - elen;
						for (var i = 0; i < len; i++) {
							end = "0" + end;
						}
					} else if (slen - elen < 0) {
						//////// 起始位补0
						var len = elen - slen;
						var start = this.bcform.start;
						for (var i = 0; i < len; i++) {
							start = "0" + start;
						}
						this.bcform.start = start;
					}
					this.bcform.end = end;
				}
			},
			batchDel() {
				this.$showMsgBox(
					this.$t("app_delete_question_2"),
					() => {
						var arr = [];
						this.sRows.forEach(item => {
							arr.push({
								deviceId: item.deviceid,
								productKey: item.productkey
							})
						});
						// {deviceId: deviceId, productKey: productKey}
						this.delRqs(arr);
					},
					""
				);
			},
			delRqs(pms) {
				this.loading = true;
				this.$aliDelEquip(
					pms,
					res => {
						this.loading = false;
						if (res.status == 200) {
							this.$message.success(res.message)
							this.getList();
						} else {
							this.$message.error(res.message);
						}
					},
					() => {
						this.loading = false;
					}
				);
			},
			delRow(item) {
				this.$showMsgBox(
					this.$t("app_delete_question"),
					() => {
						this.$agentsqueakyUnbind({deviceId: item.deviceId }, (res) => {
							console.log(res)
							this.$message.success(res.message)
							this.getList()
						}, (err) => {
							this.$message.error(err.body.message)
						})
					},
					""
				);
			},
			importPd() {
				this.showpdip = true;
				this.setMcCtr("");
			},
			addTer() {
				this.showDia = true;
				this.isEdit = false;
				this.setMcCtr("");
				this.setProCtr("");
			},
			addBcTer() {
				this.showDiaBc = true;
				this.setMcCtr("");
				this.setProCtr("");
			},
			toDetail(row) {
				this.$router.push({
					path: "/squeaky/device/detail",
					query: {
						deviceId: row.deviceId,
					}
				});
			},
			rowClick(row, column) {
				if (column.label != this.$t('app_operation')) {
					this.toDetail(row);
				}
			},
			getList() {
				this.loading = true;
				this.$squeakyDeviceList({
						page: this.page,
						rows: this.$gRow,
						clientKey: this.select_form.clientKey,
						deviceId: this.select_form.deviceId,
						smid: this.select_form.smid,
						status: this.select_form.status
					},
					res => {
						this.loading = false;
						if (res.status == 200) {
							this.total = res.total;
							this.tableData = res.data;
						} else {
							this.$message.error(res.message);
						}
					},
					""
				);
				return

				this.$squeakyDeviceList(
					this.page,
					this.$gRow,
					deviceIdVal,
					this.model,
					this.networkType,
					agentIdVal,
					merchantId,
					agentIdSearch,
					status,
					terType,
					this.sig,
					this.sig1,
					this.ssort,
					this.deviceUpdown,
					this.isLike ? 1 : 0,
					res => {
						this.loading = false;
						if (res.status == 200) {
							this.total = res.total;
							this.tableData = res.data;
							//console.log('equipment getList: '+JSON.stringify(res.data))
						} else {
							this.$message.error(res.message);
						}
					},
					""
				);
			},
			batchSelected(val) {
				this.sRows = val;
			},
			closeDia() {
				this.showImport = false;
				this.cfile = "";
				this.ready = false;
				this.import_form = {};
			},
			closeProd() {
				this.showpdip = false;
				this.pdform = {
					order: '',
					mech: '',
					model: "",
					type: '0'
				}
			},
			srcbf() {
				if (this.sig <= this.sig1) {
					this.searchEquip()
				} else {
					this.$message.error(this.$t("app_rnage_error"))
				}
			},
			searchEquip() {
				this.page = 1;
				this.getList();
			},
			ImportEquip() {
				this.showImport = true;
			},
			unbind(row) {
				this.$showMsgBox(
					this.$t("terminal.sure_unbind") + row.deviceid + "?",
					() => {
						this.unbindRqs(row.deviceid);
					},
					""
				);
			},
			unbindRqs(deviceid) {
				this.$unbindMerch(
					deviceid,
					res => {
						if (res.status == 200) {
							this.getList();
						} else {
							this.$message.error(res.message);
						}
					},
					""
				);
			},
			setMcCtr(vl) {
				var _this = this;
				this.editMc = {
					// type:'0',
					size: "",
					vlkey: "clientKey",
					value: vl ? vl : "",
					callback: vl => {
						if (this.showpdip) {
							_this.pdform.mech = vl;
						} else if (this.showDia) {
							_this.tform.merchant = vl;
						} else {
							_this.bcform.mech = vl;
						}
					}
				};
			},
			setProCtr(vl) {
				var _this = this;
				this.editModel = {
					size: "middle",
					isbatch: false,
					value: vl ? vl : "",
					callback: vl => {
						if (this.showDia) {
							_this.tform.productKey = vl;
						} else {
							_this.bcform.productkey = vl;
						}
					}
				};
			},
			get_mech_list() {
				this.$agentsqueakyCtrlList(res => {
					if (res.status == 200) {
						this.mech_list = res.data
					}
				}, '')
			},
		},
		mounted() {
			this.getList()
			this.get_mech_list()
			/*    this.editMc = {
			  size: '',
			  value: '',
			  callback: (vl) => {
			    this.tform.clientkey = vl
			  }
			}
			this.editModel = {
			  size: '',
			  value: '',
			  callback: (vl) => {
			    this.tform.type = vl
			    this.tform.productkey = vl
			  }
			}*/
		}
	};
</script>


<style scoped>
	.left_label {
		width: 30%;
		min-width: 80px;
		font-size: 14px;
	}

	.right_label {
		width: 70%;
	}
</style>
<style scoped>
	.ipeqnum {
		width: 32px;
		height: 32px;
		line-height: 32px;
		text-align: center;
		position: absolute;
		border: 1px solid rgba(0, 0, 0, 0.15);
		color: rgba(0, 0, 0, 0.25);
		font-weight: 400;
		left: -48px;
		border-radius: 32px;
	}

	.ipeqspl {
		height: 34px;
		width: 1px;
		left: -32px;
		top: 55px;
		position: absolute;
		background: rgba(0, 0, 0, 0.15);
	}

	.ipeqspl1 {
		height: 34px;
		width: 1px;
		left: -32px;
		top: -55px;
		position: absolute;
		background: rgba(0, 0, 0, 0.15);
	}

	.ipeqspl2 {
		height: 17px;
		width: 1px;
		left: -32px;
		top: -22px;
		position: absolute;
		background: rgba(0, 0, 0, 0.15);
	}

	.ipeqtt {
		font-size: 16px;
		color: rgba(0, 0, 0, 0.85);
	}
</style>